import { render, staticRenderFns } from "./SeoSellerContent.vue?vue&type=template&id=9d794394&"
import script from "./SeoSellerContent.vue?vue&type=script&lang=js&"
export * from "./SeoSellerContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports